/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Faq_Q_ProxyInputs */



/**
* | output |
* | --- |
* | "What is a proxy (non-competing) player?" |
*
* @param {Og_Faq_Q_ProxyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_faq_q_proxy = /** @type {((inputs?: Og_Faq_Q_ProxyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Faq_Q_ProxyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Qu'est-ce qu'un joueur proxy (non-compétitif) ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Qué es un jugador proxy (no competidor)?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O que é um jogador proxy (não competidor)?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cos'è un giocatore proxy (non competitivo)?")
	return /** @type {LocalizedString} */ ("What is a proxy (non-competing) player?")
});